<template>
  <el-dialog
    :title="'未完成'+data.length+'人'"
    :visible.sync="showInCompleted"
    width="540px"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="false"
    destroy-on-close
    @closed="handleClose"
    class="inCompleted"
    :close-on-click-modal="false"
  >
    <div class="inCompleted-list">
      <div class="inCompleted-item" v-for="x in data">
        <div class="avatar">
          <img :src="preViewUrl+x.avatar">
        </div>
        <div class="nickname">
          <label>{{x.nickname}}</label>
        </div>
      </div>
<!--      <div class="inCompleted-item">-->
<!--        <div class="avatar">-->
<!--          <img src="https://dss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3724506413,4235283691&fm=26&gp=0.jpg">-->
<!--        </div>-->
<!--        <div class="nickname">-->
<!--          <label>花遇和风</label>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="inCompleted-item">-->
<!--        <div class="avatar">-->
<!--          <img src="https://dss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3724506413,4235283691&fm=26&gp=0.jpg">-->
<!--        </div>-->
<!--        <div class="nickname">-->
<!--          <label>花遇和风</label>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="inCompleted-item">-->
<!--        <div class="avatar">-->
<!--          <img src="https://dss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3724506413,4235283691&fm=26&gp=0.jpg">-->
<!--        </div>-->
<!--        <div class="nickname">-->
<!--          <label>花遇和风</label>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="inCompleted-item">-->
<!--        <div class="avatar">-->
<!--          <img src="https://dss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3724506413,4235283691&fm=26&gp=0.jpg">-->
<!--        </div>-->
<!--        <div class="nickname">-->
<!--          <label>花遇和风</label>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="inCompleted-item">-->
<!--        <div class="avatar">-->
<!--          <img src="https://dss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3724506413,4235283691&fm=26&gp=0.jpg">-->
<!--        </div>-->
<!--        <div class="nickname">-->
<!--          <label>花遇和风</label>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="inCompleted-item">-->
<!--        <div class="avatar">-->
<!--          <img src="https://dss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3724506413,4235283691&fm=26&gp=0.jpg">-->
<!--        </div>-->
<!--        <div class="nickname">-->
<!--          <label>花遇和风</label>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "incomplete",
  props:{
    showInCompleted:{
      type:Boolean,
      default:false
    },
    data:{
      type:Array,
      default:()=>{}
    }
  },
  methods: {
    handleOpen() {

    },
    handleClose() {
      this.$emit("close", false)
    }
  },
  computed:{
    preViewUrl(){
      return this.$common.SystemConfig.PreViewUrl
    }
  },
}
</script>

<style slot-scope lang="scss">
.inCompleted{
  .el-dialog{
    .el-dialog__header{
      text-align: center;
    }
    .inCompleted-list{
      display: flex;
      flex-wrap: wrap;
      .inCompleted-item{
        cursor: pointer;
        width: 100px;
        height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        .avatar{
          img{
            border-radius: 100%;
            width: 60px;
            height: 60px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-help/axj-course/component/home-work/component/incomplete/index.vue